'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relatedFiltersByHash = exports.filtersByQuery = exports.filtersByHash = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sagaTools = require('@classpass/saga-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTERS_TIMEOUT = 5000; // Default timeout for Filters API, as a temporary measure while core cause for timeouts is investigated.

var filtersByHash = exports.filtersByHash = (0, _sagaTools.makeEntityScaffold)('SAGA.API.FILTERS_BY_HASH', function (client, hash, overrides) {
  return client.filters.getByHash(hash, null, (0, _extends3.default)({ timeout: FILTERS_TIMEOUT }, overrides)) // has URL params, second argument is query params, third is overrides.
  .then(function (data) {
    return data.data;
  });
}, { defaultKey: 1 });

var filtersByQuery = exports.filtersByQuery = (0, _sagaTools.makeEntityScaffold)('SAGA.API.FILTERS_BY_QUERY', function (client, params, overrides) {
  return client.filters.getByQuery(params, (0, _extends3.default)({ timeout: FILTERS_TIMEOUT }, overrides)) // has no URL params, second argument is overrides.
  .then(function (data) {
    return data.data;
  });
});

var relatedFiltersByHash = exports.relatedFiltersByHash = (0, _sagaTools.makeEntityScaffold)('SAGA.API.RELATED_FILTERS_BY_HASH', function (client, hash, overrides) {
  return client.filters.getRelatedByHash(hash, null, (0, _extends3.default)({ timeout: FILTERS_TIMEOUT }, overrides)).then(function (data) {
    return data.data;
  }).then(function (data) {
    return data.groups;
  }).then(function (groups) {
    return groups.filter(function (group) {
      return group.filters && group.filters.length;
    });
  });
}, { defaultKey: 1 });